import {
  CheckCircleOutlined,
  MinusCircleOutlined,
  PlayCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { Space, Tooltip, Typography } from 'antd';

import { PAYMENTS_ACCOUNTS_LABEL } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NTables } from '@app/types/Tables';

import type { ColumnsType } from 'antd/es/table';

export const KEY = 'key';
export const AVATAR = 'avatar';
export const DATA_INDEX = 'dataIndex';
export const NAME = 'name';
export const CONTACTS = 'contacts';
export const TITLE = 'title';
export const RIGHTS = 'rights';
export const LAST_VISIT = 'lastVisit';
export const ACTIONS = 'actions';
export const WIDTH = 'width';
export const ELLIPSIS = 'ellipsis';
export const CHILDREN = 'children';
export const CLASS_NAME = 'className';
export const MESSAGE = 'message';
export const FIXED = 'fixed';

// U - префикс от Upper (регистр первого символа)
export const U_KEY = 'Key';
export const U_NAME = 'Name';
export const U_PHONE = 'Phone';
export const U_ACTION = 'Action';
export const U_DESCRIPTION = 'Description';
export const U_ROLES = 'Roles';
export const U_STATUS = 'Status';
export const U_SERVICES = 'Services';
export const U_SCHEDULE = 'Schedule';
export const U_CATEGORY = 'Category';
export const U_PRICE = 'Price';
export const U_DURATION = 'Duration';
export const U_EMPLOYEES = 'Employees';
export const U_EMPLOYEE = 'Employee';
export const U_CLIENT_SERVICES = 'ClientServices';
export const U_CLIENT_SERVICES_COST = 'ClientServicesCost';
export const U_CLIENT = 'Client';
export const U_TIME = 'Time';
export const U_CREATE_USER = 'CreateUser';
export const U_ID = 'Id';
export const U_MONEY_SPENT = 'MoneySpent';
export const U_COUNT_VISITS = 'CountVisits';
export const U_DATE_VISIT_FIRST = 'DateVisitFirst';
export const U_DATE_VISIT_LAST = 'DateVisitLast';
export const U_BALANCE = 'Balance';
export const U_VISIT_FREQUENCY = 'VisitFrequency';
export const U_KPP = 'Kpp';
export const U_COUNT_CONSTANTS_PAYMENTS = 'CountConstantsPayments';
export const U_TAX_PAYER_ID = 'TaxPayerId';
export const U_LEGAL_ENTITY = 'LegalEntity';
export const U_PAY_TYPE = 'PayType';
export const U_IS_DEFAULT = 'IsDefault';
export const U_INTEGRATIONS = 'Integrations';
export const U_LOGIN = 'Login';
export const U_SALES_FUNNELS = 'SalesFunnels';
export const U_OPERATIONS = 'Operations';
export const U_SUM = 'Summary';
export const U_USER = 'User';
export const U_ARTICLE = 'Article';
export const U_DETAILS = 'Details';
export const U_COMMENT = 'Comment';
export const U_DIRECTION = 'Direction';
export const U_REVENUE = 'Revenue';
export const U_SHARE_OF_TOTAL_AMOUNT = 'ShareOfTotalAmount';
export const U_PLAN = 'Plan';
export const U_FOR_A_PERIOD = 'ForAPeriod';
export const U_PERFORMANCE = 'Performance';
export const U_LAG = 'Lag';
export const U_CLIENTS = 'Clients';
export const U_PRIMARY = 'Primary';
export const U_SECONDARY = 'Secondary';
export const U_AMOUNT = 'Amount';
export const U_AMOUNT_1 = 'Amount1';
export const U_AMOUNT_2 = 'Amount2';
export const U_AMOUNT_3 = 'Amount3';
export const U_AVERAGE_CHECK = 'AverageCheck';
export const U_AVERAGE_CHECK_1 = 'AverageCheck1';
export const U_QUANTITY = 'Quantity';
export const U_QUANTITY_1 = 'Quantity1';
export const U_QUANTITY_2 = 'Quantity2';
export const U_QUANTITY_3 = 'Quantity3';
export const U_QUANTITY_IN_BRANCH = 'QuantityInBranch';
export const U_UPSELLS = 'Upsells';
export const U_INSIDE_DIRECTION = 'InsideDirection';
export const U_OUTSIDE_DIRECTION = 'OutsideDirection';
export const U_ADDRESS = 'Address';
export const U_TYPE = 'Type';
export const U_PROTOCOL = 'Protocol';
export const U_PORT = 'Port';
export const U_COUNTRY = 'Country';
export const U_USED_CHANNELS = 'UsedChannels';
export const U_VALIDITY = 'Validity';
export const U_WARNING = 'Warning';
export const U_POSITION = 'Position';
export const U_EXECUTION_DATE = 'ExecutionDate';
export const U_TASK = 'Task';
export const U_LOYALTY_CARD = 'IsLoyaltyCard';
export const U_TASK_TYPE = 'TaskType';
export const U_IN_PROGRESS = 'InProgress';
export const U_SUCCESS = 'Success';
export const U_UNSUCCESSFUL = 'Unsuccessful';
export const U_CITY = 'City';
export const U_BRANCH = 'Branch';
export const U_OWNER = 'Owner';
export const U_START_DATE = 'StartDate';
export const U_RECEIVERS_COUNT = 'ReceiversCount';
export const U_SENT_COUNT = 'SentCount';
export const U_REPLIED_COUNT = 'RepliedCount';
export const U_MADE_RECORD_COUNT = 'MadeRecordCount';
export const U_INSTAGRAM = 'Instagram';
export const U_VERSION_FRONTEND = 'VersionFrontend';
export const U_COUNT_CLIENT_REPLIES = 'CountClientReplies';
export const U_COUNT_CLIENT_RECORDS = 'CountClientRecords';
export const U_SENDOUT_CONVERSION = 'SendoutConversion';
export const U_CLIENT_RECORDS_COST = 'ClientRecordsCost';
export const U_IS_CLIENT_REPLIED = 'IsClientReplied';
export const U_IS_CLIENT_RECORDED = 'IsClientRecorded';
export const IS_DELETED = 'isDeleted';
export const U_TAGS = 'Tags';
export const U_SALARY = 'Salary';

export const USER_TABLE_HEADER: ColumnsType<NTables.Users> = [
  {
    [TITLE]: '',
    [DATA_INDEX]: AVATAR,
    [KEY]: AVATAR,
    [WIDTH]: '70px',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Имя', 'names-title'),
    [DATA_INDEX]: NAME,
    [KEY]: NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Контакты', 'contacts-title'),
    [DATA_INDEX]: CONTACTS,
    [KEY]: CONTACTS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Права', 'rights-title'),
    [DATA_INDEX]: RIGHTS,
    [KEY]: RIGHTS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Последний визит', 'last-visit-title'),
    [DATA_INDEX]: LAST_VISIT,
    [KEY]: LAST_VISIT,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: ACTIONS,
    [KEY]: ACTIONS,
  },
];

// Column widths are minimums used to size the horizontal scroll (see
// CLIENTS_TABLE_SCROLL_X below), keeping narrow columns from being squeezed
// below a usable width on small screens.
export const CLIENT_TABLE_HEADER: ColumnsType<NTables.ClientsHeader> = [
  {
    [TITLE]: 'Имя',
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
    [WIDTH]: 200,
  },
  {
    [TITLE]: 'Телефон',
    [DATA_INDEX]: U_PHONE,
    [KEY]: U_PHONE,
    [WIDTH]: 150,
  },
  {
    [TITLE]: 'Баланс',
    [DATA_INDEX]: U_BALANCE,
    [KEY]: U_BALANCE,
    [WIDTH]: 110,
  },
  {
    [TITLE]: 'Продано',
    [DATA_INDEX]: U_MONEY_SPENT,
    [KEY]: U_MONEY_SPENT,
    [WIDTH]: 110,
  },
  {
    [TITLE]: 'Визиты',
    [DATA_INDEX]: U_COUNT_VISITS,
    [KEY]: U_COUNT_VISITS,
    [WIDTH]: 90,
  },
  {
    [TITLE]: 'Первый визит',
    [DATA_INDEX]: U_DATE_VISIT_FIRST,
    [KEY]: U_DATE_VISIT_FIRST,
    [WIDTH]: 150,
  },
  {
    [TITLE]: 'Последний визит',
    [DATA_INDEX]: U_DATE_VISIT_LAST,
    [KEY]: U_DATE_VISIT_LAST,
    [WIDTH]: 150,
  },
  {
    [TITLE]: 'Наличие задач',
    [DATA_INDEX]: U_TASK,
    [KEY]: U_TASK,
    [WIDTH]: 130,
  },
  {
    [TITLE]: 'Карта лояльности',
    [DATA_INDEX]: U_LOYALTY_CARD,
    [KEY]: U_LOYALTY_CARD,
    [WIDTH]: 150,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: 100,
  },
];

export const CLIENTS_TABLE_SCROLL_X = 1340;

export const TAGS_HEADER: ColumnsType<NTables.TagsHeader> = [
  {
    [TITLE]: generateSpanWithDataTestId('Имя', 'tag-name-title'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Описание', 'tag-description-title'),
    [DATA_INDEX]: U_DESCRIPTION,
    [KEY]: U_DESCRIPTION,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: '10%',
    className: 'actions-cell',
  },
];

export const EMPLOYEES_HEADER: ColumnsType<NTables.EmployeesHeader> = [
  {
    [TITLE]: generateSpanWithDataTestId('Имя', 'employees-names'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId(
      'Оказывает услуги',
      'employees-services'
    ),
    [DATA_INDEX]: U_SERVICES,
    [KEY]: U_SERVICES,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Расписание до', 'employees-schedule'),
    [DATA_INDEX]: U_SCHEDULE,
    [KEY]: U_SCHEDULE,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: '10%',
  },
];

export const POSITIONS_HEADER: ColumnsType<NTables.PositionsHeader> = [
  {
    [TITLE]: generateSpanWithDataTestId('Имя', 'position-name-title'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId(
      'Описание',
      'position-description-title'
    ),
    [DATA_INDEX]: U_DESCRIPTION,
    [KEY]: U_DESCRIPTION,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Роли', 'position-roles-title'),
    [DATA_INDEX]: U_ROLES,
    [KEY]: U_ROLES,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: '10%',
  },
];

export const CLIENT_SERVICES_HEADER: ColumnsType<NTables.ClientServicesHeader> =
  [
    {
      [TITLE]: 'Категория',
      [DATA_INDEX]: U_CATEGORY,
      [KEY]: U_CATEGORY,
    },
    {
      [TITLE]: 'Название',
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
    },
    {
      [TITLE]: 'Цена',
      [DATA_INDEX]: U_PRICE,
      [KEY]: U_PRICE,
    },
    {
      [TITLE]: 'Длительность',
      [DATA_INDEX]: U_DURATION,
      [KEY]: U_DURATION,
    },
    {
      [TITLE]: 'Исполнители',
      [DATA_INDEX]: U_EMPLOYEES,
      [KEY]: U_EMPLOYEES,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
      [WIDTH]: '10%',
    },
  ];

// Column widths are sized by the meaning of each column: compact numeric/date
// columns stay narrow, name/service columns get more room, tags widest. The
// action column width is overridden (fixed) in the Records table component.
export const RECORDS_SERVICE_HEADER: ColumnsType<NTables.RecordsServiceHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId('Время визита', 'visit-time-title'),
      [DATA_INDEX]: U_TIME,
      [KEY]: U_TIME,
      [WIDTH]: '150px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Услуга', 'service-title'),
      [DATA_INDEX]: U_CLIENT_SERVICES,
      [KEY]: U_CLIENT_SERVICES,
      [WIDTH]: '220px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Сумма', 'service-sum-title'),
      [DATA_INDEX]: U_CLIENT_SERVICES_COST,
      [KEY]: U_CLIENT_SERVICES_COST,
      [WIDTH]: '90px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Исполнитель', 'executor-title'),
      [DATA_INDEX]: U_EMPLOYEE,
      [KEY]: U_EMPLOYEE,
      [WIDTH]: '170px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Клиент', 'client-title'),
      [DATA_INDEX]: U_CLIENT,
      [KEY]: U_CLIENT,
      [WIDTH]: '175px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Создал', 'created-by-title'),
      [DATA_INDEX]: U_CREATE_USER,
      [KEY]: U_CREATE_USER,
      [WIDTH]: '150px',
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Статус визита',
        'visit-status-title'
      ),
      [DATA_INDEX]: U_STATUS,
      [KEY]: U_STATUS,
      [WIDTH]: '150px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Теги', 'tags-title'),
      [DATA_INDEX]: U_TAGS,
      [KEY]: U_TAGS,
      [WIDTH]: '290px',
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
      [WIDTH]: '64px',
    },
  ];

export const SORT_EMPLOYEES_HEADER: ColumnsType<NTables.SortEmployeesHeader> = [
  {
    [KEY]: 'sort',
    [CLASS_NAME]: 'burger-icon',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Имя', 'employees-names'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Должность', 'employees-positions'),
    [DATA_INDEX]: U_POSITION,
    [KEY]: U_POSITION,
  },
];

export const RECORDS_TAGS_HEADER: ColumnsType<NTables.RecordsTagsHeader> = [
  {
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [DATA_INDEX]: U_DESCRIPTION,
    [KEY]: U_DESCRIPTION,
  },
];

export const EMPLOYEES_CLIENTS_SERVICES_HEADER: ColumnsType<NTables.EmployeesClientServicesHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId('Категория', 'category-title'),
      [DATA_INDEX]: U_CATEGORY,
      [KEY]: U_CATEGORY,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Название', 'service-name-title'),
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
      [WIDTH]: '200px',
    },
    {
      [TITLE]: generateSpanWithDataTestId('Длительность', 'duration-title'),
      [DATA_INDEX]: U_DURATION,
      [KEY]: U_DURATION,
    },
    {
      [TITLE]: 'Заработная плата',
      [DATA_INDEX]: U_SALARY,
      [KEY]: U_SALARY,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
      [WIDTH]: '32px',
      fixed: 'right',
      align: 'right',
    },
  ];

export const LEGAL_ENTITIES_HEADER: ColumnsType<NTables.LegalEntitiesHeader> = [
  {
    [TITLE]: generateSpanWithDataTestId('Наименование', 'name-title'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId('ИНН', 'tin-title'),
    [DATA_INDEX]: U_TAX_PAYER_ID,
    [KEY]: U_TAX_PAYER_ID,
  },
  {
    [TITLE]: generateSpanWithDataTestId('КПП', 'tax-registration-number-title'),
    [DATA_INDEX]: U_KPP,
    [KEY]: U_KPP,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Примечание', 'comment-title'),
    [DATA_INDEX]: U_DESCRIPTION,
    [KEY]: U_DESCRIPTION,
  },
  {
    [TITLE]: generateSpanWithDataTestId(
      PAYMENTS_ACCOUNTS_LABEL,
      'payments-account-title'
    ),
    [DATA_INDEX]: U_COUNT_CONSTANTS_PAYMENTS,
    [KEY]: U_COUNT_CONSTANTS_PAYMENTS,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: '10%',
  },
];

export const PAYMENTS_ACCOUNTS_HEADER: ColumnsType<NTables.PaymentsAccountHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId(
        'Название',
        'name-payment-account-title'
      ),
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_IS_DEFAULT,
      [KEY]: U_IS_DEFAULT,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Юридическое лицо',
        'legal-entity-title'
      ),
      [DATA_INDEX]: U_LEGAL_ENTITY,
      [KEY]: U_LEGAL_ENTITY,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Метод оплаты',
        'payment-method-title'
      ),
      [DATA_INDEX]: U_PAY_TYPE,
      [KEY]: U_PAY_TYPE,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Баланс', 'balance-title'),
      [DATA_INDEX]: U_BALANCE,
      [KEY]: U_BALANCE,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Примечание', 'note-title'),
      [DATA_INDEX]: U_DESCRIPTION,
      [KEY]: U_DESCRIPTION,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
      [WIDTH]: '10%',
    },
  ];

export const INTEGRATIONS_HEADER: ColumnsType<NTables.Integrations> = [
  {
    [TITLE]: generateSpanWithDataTestId('Интеграция', 'integration-title'),
    [DATA_INDEX]: U_INTEGRATIONS,
    [KEY]: U_INTEGRATIONS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Аккаунт', 'account-title'),
    [DATA_INDEX]: U_LOGIN,
    [KEY]: U_LOGIN,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Воронка, этап', 'funnel-stage-title'),
    [DATA_INDEX]: U_SALES_FUNNELS,
    [KEY]: U_SALES_FUNNELS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Статус', 'status-title'),
    [DATA_INDEX]: U_STATUS,
    [KEY]: U_STATUS,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
    [WIDTH]: '10%',
  },
];

export const CLIENTS_PAYMENTS_HEADER: ColumnsType<NTables.ClientPayments> = [
  {
    [TITLE]: generateSpanWithDataTestId('Операция', 'operation-title'),
    [DATA_INDEX]: U_OPERATIONS,
    [KEY]: U_OPERATIONS,
    className: 'operations',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Сумма', 'operation-sum-title'),
    [DATA_INDEX]: U_SUM,
    [KEY]: U_SUM,
    className: 'sum',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Клиент', 'client-title'),
    [DATA_INDEX]: U_CLIENT,
    [KEY]: U_CLIENT,
    className: 'client',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Пользователь', 'user-title'),
    [DATA_INDEX]: U_USER,
    [KEY]: U_USER,
    className: 'user',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Статья', 'article-title'),
    [DATA_INDEX]: U_ARTICLE,
    [KEY]: U_ARTICLE,
    className: 'article',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Детали', 'details-title'),
    [DATA_INDEX]: U_DETAILS,
    width: 300,
    [KEY]: U_DETAILS,
    className: 'details',
  },
  {
    [TITLE]: generateSpanWithDataTestId('Комментарий', 'comment-title'),
    [DATA_INDEX]: U_COMMENT,
    [KEY]: U_COMMENT,
    className: 'comment',
  },
];

export const DIRECTION_INDICATORS_HEADER: ColumnsType<NTables.DirectionIndicators> =
  [
    {
      [TITLE]: 'Направление',
      [DATA_INDEX]: U_DIRECTION,
      [KEY]: U_DIRECTION,
      [FIXED]: 'left',
      [WIDTH]: 200,
    },
    {
      [TITLE]: 'Доход',
      [DATA_INDEX]: U_REVENUE,
      [KEY]: U_REVENUE,
      [CHILDREN]: [
        {
          [TITLE]: 'Сумма',
          [DATA_INDEX]: U_SUM,
          [KEY]: U_SUM,
        },
        {
          [TITLE]: 'Доля от общей суммы, %',
          [DATA_INDEX]: U_SHARE_OF_TOTAL_AMOUNT,
          [KEY]: U_SHARE_OF_TOTAL_AMOUNT,
        },
      ],
    },
    {
      [TITLE]: 'План',
      [DATA_INDEX]: U_PLAN,
      [KEY]: U_PLAN,
      [CHILDREN]: [
        {
          [TITLE]: 'На период',
          [DATA_INDEX]: U_FOR_A_PERIOD,
          [KEY]: U_FOR_A_PERIOD,
        },
        {
          [TITLE]: 'Выполнение, %',
          [DATA_INDEX]: U_PERFORMANCE,
          [KEY]: U_PERFORMANCE,
        },
        {
          [TITLE]: 'Отставание',
          [DATA_INDEX]: U_LAG,
          [KEY]: U_LAG,
        },
      ],
    },
    {
      [TITLE]: 'Клиенты',
      [DATA_INDEX]: U_CLIENTS,
      [KEY]: U_CLIENTS,
      [CHILDREN]: [
        {
          [TITLE]: 'Первичные',
          [DATA_INDEX]: U_PRIMARY,
          [KEY]: U_PRIMARY,
          [CHILDREN]: [
            {
              [TITLE]: 'Кол-во в направлении',
              [DATA_INDEX]: U_QUANTITY,
              [KEY]: U_QUANTITY,
            },
            {
              [TITLE]: 'Кол-во в филиале',
              [DATA_INDEX]: U_QUANTITY_IN_BRANCH,
              [KEY]: U_QUANTITY_IN_BRANCH,
            },
            {
              [TITLE]: 'Сумма',
              [DATA_INDEX]: U_AMOUNT_2,
              [KEY]: U_AMOUNT_2,
            },
            {
              [TITLE]: 'Средний чек',
              [DATA_INDEX]: U_AVERAGE_CHECK,
              [KEY]: U_AVERAGE_CHECK,
            },
          ],
        },
        {
          [TITLE]: 'Вторичные',
          [DATA_INDEX]: U_SECONDARY,
          [KEY]: U_SECONDARY,
          [CHILDREN]: [
            {
              [TITLE]: 'Кол-во',
              [DATA_INDEX]: U_QUANTITY_1,
              [KEY]: U_QUANTITY_1,
            },
            {
              [TITLE]: 'Сумма',
              [DATA_INDEX]: U_AMOUNT_3,
              [KEY]: U_AMOUNT_3,
            },
            {
              [TITLE]: 'Средний чек',
              [DATA_INDEX]: U_AVERAGE_CHECK_1,
              [KEY]: U_AVERAGE_CHECK_1,
            },
          ],
        },
      ],
    },
    // Скрыто в рамках таски task/5716. Оставляю на случай, если нужно будет вернуть
    // {
    //   [TITLE]: 'Дополнительные продажи',
    //   [DATA_INDEX]: U_UPSELLS,
    //   [KEY]: U_UPSELLS,
    //   [CHILDREN]: [
    //     {
    //       [TITLE]: 'Внутри направления',
    //       [DATA_INDEX]: U_INSIDE_DIRECTION,
    //       [KEY]: U_INSIDE_DIRECTION,
    //       [CHILDREN]: [
    //         {
    //           [TITLE]: 'Кол-во',
    //           [DATA_INDEX]: U_QUANTITY_2,
    //           [KEY]: U_QUANTITY_2,
    //         },
    //         {
    //           [TITLE]: 'Сумма',
    //           [DATA_INDEX]: U_AMOUNT,
    //           [KEY]: U_AMOUNT,
    //         },
    //       ],
    //     },
    //     {
    //       [TITLE]: 'Снаружи направления',
    //       [DATA_INDEX]: U_OUTSIDE_DIRECTION,
    //       [KEY]: U_OUTSIDE_DIRECTION,
    //       [CHILDREN]: [
    //         {
    //           [TITLE]: 'Кол-во',
    //           [DATA_INDEX]: U_QUANTITY_3,
    //           [KEY]: U_QUANTITY_3,
    //         },
    //         {
    //           [TITLE]: 'Сумма',
    //           [DATA_INDEX]: U_AMOUNT_1,
    //           [KEY]: U_AMOUNT_1,
    //         },
    //       ],
    //     },
    //   ],
    // },
  ];

export const TASK_LIST_HEADER: ColumnsType<NTables.TaskListHeader> = [
  {
    [TITLE]: 'Дата исполнения / Отв.',
    [DATA_INDEX]: U_EXECUTION_DATE,
    [KEY]: U_EXECUTION_DATE,
    [WIDTH]: 200,
    [ELLIPSIS]: true,
  },
  {
    [TITLE]: 'Клиент или запись',
    [DATA_INDEX]: U_CLIENT,
    [KEY]: U_CLIENT,
    [WIDTH]: 200,
    [ELLIPSIS]: true,
  },
  {
    [TITLE]: 'Тип',
    [DATA_INDEX]: U_TASK_TYPE,
    [KEY]: U_TASK_TYPE,
    [WIDTH]: 160,
    [ELLIPSIS]: true,
  },
  {
    [TITLE]: 'Задача',
    [DATA_INDEX]: U_TASK,
    [KEY]: U_TASK,
    [WIDTH]: 250,
    [ELLIPSIS]: true,
  },
  {
    [TITLE]: 'Статус',
    [DATA_INDEX]: U_STATUS,
    [KEY]: U_STATUS,
    [WIDTH]: 200,
    [ELLIPSIS]: true,
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: ACTIONS,
    [KEY]: ACTIONS,
    [WIDTH]: 100,
    [ELLIPSIS]: true,
  },
];

export const SALES_FUNNELS_HEADER: ColumnsType<NTables.SalesFunnelsHeader> = [
  {
    [TITLE]: 'Название и описание',
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
    [WIDTH]: '250px',
  },
  {
    [TITLE]: (
      <>
        <PlayCircleOutlined className="play-icon" /> В работе
      </>
    ),
    [DATA_INDEX]: U_IN_PROGRESS,
    [KEY]: U_IN_PROGRESS,
    [CLASS_NAME]: 'in-progress-column',
  },
  {
    [TITLE]: (
      <>
        <CheckCircleOutlined className="check-icon" /> Успешные
      </>
    ),
    [DATA_INDEX]: U_SUCCESS,
    [KEY]: U_SUCCESS,
    [CLASS_NAME]: 'success-column',
  },
  {
    [TITLE]: (
      <>
        <MinusCircleOutlined className="minus-icon" /> Неуспешные
      </>
    ),
    [DATA_INDEX]: U_UNSUCCESSFUL,
    [KEY]: U_UNSUCCESSFUL,
    [CLASS_NAME]: 'unsuccess-column',
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: ACTIONS,
    [KEY]: ACTIONS,
    fixed: 'right',
  },
];

export const ORGANIZATIONS_TABLE_HEADER: ColumnsType<NTables.OrganizationsHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId('Название', 'name-title'),
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Город', 'city-title'),
      [DATA_INDEX]: U_CITY,
      [KEY]: U_CITY,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Филиал, адрес',
        'branch-address-title'
      ),
      [DATA_INDEX]: U_BRANCH,
      [KEY]: U_BRANCH,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Представитель',
        'representative-title'
      ),
      [DATA_INDEX]: U_OWNER,
      [KEY]: U_OWNER,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
    },
  ];

export const SENDOUTS_TABLE_HEADER: ColumnsType<NTables.SendoutsHeader> = [
  {
    [TITLE]: generateSpanWithDataTestId('Название', 'name-title'),
    [DATA_INDEX]: U_NAME,
    [KEY]: U_NAME,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Канал, интеграция', 'channel-title'),
    [DATA_INDEX]: U_INTEGRATIONS,
    [KEY]: U_INTEGRATIONS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Старт', 'start-date-time-title'),
    [DATA_INDEX]: U_START_DATE,
    [KEY]: U_START_DATE,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Получатели', 'recipients-title'),
    [DATA_INDEX]: U_RECEIVERS_COUNT,
    [KEY]: U_RECEIVERS_COUNT,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Отправлено', 'sent-title'),
    [DATA_INDEX]: U_SENT_COUNT,
    [KEY]: U_SENT_COUNT,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Ответили', 'replied-title'),
    [DATA_INDEX]: U_COUNT_CLIENT_REPLIES,
    [KEY]: U_COUNT_CLIENT_REPLIES,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Записались', 'booked-title'),
    [DATA_INDEX]: U_COUNT_CLIENT_RECORDS,
    [KEY]: U_COUNT_CLIENT_RECORDS,
  },
  {
    [TITLE]: generateSpanWithDataTestId('Конверсия, %', 'conversion-title'),
    [DATA_INDEX]: U_SENDOUT_CONVERSION,
    [KEY]: U_SENDOUT_CONVERSION,
    onCell: () => {
      return {
        style: { minWidth: 130 },
      };
    },
  },
  {
    [TITLE]: generateSpanWithDataTestId('Сумма', 'amount-title'),
    [DATA_INDEX]: U_CLIENT_RECORDS_COST,
    [KEY]: U_CLIENT_RECORDS_COST,
    onCell: () => {
      return {
        style: { minWidth: 110 },
      };
    },
  },
  {
    [TITLE]: generateSpanWithDataTestId('Статус', 'status-title'),
    [DATA_INDEX]: U_STATUS,
    [KEY]: U_STATUS,
    onCell: () => {
      return {
        style: { minWidth: 120 },
      };
    },
  },
  {
    [TITLE]: '',
    [DATA_INDEX]: U_ACTION,
    [KEY]: U_ACTION,
  },
];

export const SENDOUT_RECEIVERS_TABLE_HEADER: ColumnsType<NTables.SendoutReceiversHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId('Имя', 'client-name-title'),
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Телефон клиента',
        'client-phone-title'
      ),
      [DATA_INDEX]: U_PHONE,
      [KEY]: U_PHONE,
      [WIDTH]: 160,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Instagram',
        'client-instagram-account-title'
      ),
      [DATA_INDEX]: U_INSTAGRAM,
      [KEY]: U_INSTAGRAM,
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('VK', 'client-vk-account-title'),
      [DATA_INDEX]: 'VK',
      [KEY]: 'VK',
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Telegram Bot',
        'client-telegram-bot-account-title'
      ),
      [DATA_INDEX]: 'TelegramBot',
      [KEY]: 'TelegramBot',
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Telegram (личный)',
        'client-telegram-account-title'
      ),
      [DATA_INDEX]: 'Telegram',
      [KEY]: 'Telegram',
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('MAX', 'client-max-account-title'),
      [DATA_INDEX]: 'Max',
      [KEY]: 'Max',
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId(
        'Loyalty',
        'client-loyalty-account-title'
      ),
      [DATA_INDEX]: 'loyalty-program-sendouts',
      [KEY]: 'loyalty-program-sendouts',
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Интеграция', 'integration-title'),
      [DATA_INDEX]: U_INTEGRATIONS,
      [KEY]: U_INTEGRATIONS,
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Статус', 'status-title'),
      [DATA_INDEX]: U_STATUS,
      [KEY]: U_STATUS,
      [WIDTH]: 200,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Есть ответ', 'answer-exists-title'),
      [DATA_INDEX]: U_IS_CLIENT_REPLIED,
      [KEY]: U_IS_CLIENT_REPLIED,
      [WIDTH]: 160,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Есть запись', 'record-exists-title'),
      [DATA_INDEX]: U_IS_CLIENT_RECORDED,
      [KEY]: U_IS_CLIENT_RECORDED,
      [WIDTH]: 160,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Сумма', 'amount-title'),
      [DATA_INDEX]: U_CLIENT_RECORDS_COST,
      [KEY]: U_CLIENT_RECORDS_COST,
      [WIDTH]: 100,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: (
        <Space size="small">
          <Typography data-testid="send-time-title">Время отправки</Typography>
          <Tooltip title="Подразумевается время отправки (попытки отправить) сообщение">
            <QuestionCircleOutlined />
          </Tooltip>
        </Space>
      ),
      [DATA_INDEX]: U_TIME,
      [KEY]: U_TIME,
      [WIDTH]: 170,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: '',
      [DATA_INDEX]: U_ACTION,
      [KEY]: U_ACTION,
      [WIDTH]: 60,
      [ELLIPSIS]: true,
    },
  ];

export const ORGANIZATION_USERS_TABLE_HEADER: ColumnsType<NTables.OrganizationUsersHeader> =
  [
    {
      [TITLE]: generateSpanWithDataTestId('Имя', 'user-name'),
      [DATA_INDEX]: U_NAME,
      [KEY]: U_NAME,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Контакты', 'user-contacts'),
      [DATA_INDEX]: U_PHONE,
      [KEY]: U_PHONE,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Филиал', 'user-branch'),
      [DATA_INDEX]: U_BRANCH,
      [KEY]: U_BRANCH,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Активность', 'user-activity'),
      [DATA_INDEX]: LAST_VISIT,
      [KEY]: LAST_VISIT,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
    {
      [TITLE]: generateSpanWithDataTestId('Обновление ПО', 'update-time'),
      [DATA_INDEX]: U_VERSION_FRONTEND,
      [KEY]: U_VERSION_FRONTEND,
      [WIDTH]: 250,
      [ELLIPSIS]: true,
    },
  ];

export const LOGS_REGISTRY_TABLE_HEADER: ColumnsType<NTables.LogsRegistryTableHeader> =
  [
    {
      [TITLE]: 'Текст сообщения',
      [DATA_INDEX]: U_DESCRIPTION,
      [KEY]: U_DESCRIPTION,
    },
    {
      [TITLE]: 'Время создания',
      [DATA_INDEX]: U_TIME,
      [KEY]: U_TIME,
    },
  ];
